"use client";

import { memo } from "react";
import { useTranslations } from "next-intl";
import type { SafeDebugUser } from "../debug-panel.types";

interface PermissionPanelProps {
  user: SafeDebugUser | null;
}

export const PermissionPanel = memo(function PermissionPanel({
  user,
}: PermissionPanelProps) {
  const t = useTranslations("debug.permissions");

  if (!user) {
    return (
      <div className="text-sm text-muted-foreground py-4 text-center">
        {t("notAuthenticated")}
      </div>
    );
  }

  const itemIds =
    user.contextKind === "WORKSPACE"
      ? (user.effectiveNavigationItemIds ?? [])
      : [];

  return (
    <div className="space-y-1">
      <div className="mb-3 px-2 py-2 rounded-lg bg-muted/20 flex items-center gap-3">
        <span className="text-sm text-muted-foreground w-32 shrink-0">
          {t("authoritySource")}
        </span>
        <span className="px-2 py-0.5 rounded font-mono text-sm font-semibold bg-muted text-muted-foreground">
          {user.contextKind === "WORKSPACE"
            ? t("effectiveNavigationSource")
            : t("notApplicable")}
        </span>
      </div>

      <div className="space-y-1 mb-3">
        <div className="text-sm font-semibold text-muted-foreground/60 uppercase tracking-wider px-2 mb-1">
          {t("effectiveNavigation", { count: itemIds.length })}
        </div>
        {itemIds.length === 0 ? (
          <div className="px-2 py-1.5 text-sm text-muted-foreground">
            {t("noItems")}
          </div>
        ) : (
          itemIds.map((itemId) => (
            <div
              key={itemId}
              className="flex items-center gap-3 px-2 py-1.5 rounded hover:bg-muted/20 text-sm"
            >
              <span className="font-mono px-1.5 py-0.5 rounded bg-muted text-muted-foreground">
                {itemId}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
});
